import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=ed0e5010&scoped=true&"
import script from "./Recycle.vue?vue&type=script&lang=js&"
export * from "./Recycle.vue?vue&type=script&lang=js&"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=ed0e5010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0e5010",
  null
  
)

export default component.exports